
import { butter } from "~/plugins/buttercms";

export default {
  name: "cal-add-to-basket-flow",
  props: {
    slotName: {
      type: String,
      required: true,
    },
    showCartDialog: {
      type: Boolean,
    },
    onSubmit: {
      type: Function,
    },
  },
  data() {
    return {
      showSlideOver: this.showCartDialog,
      disableTabChange: false,
      pageData: {},
    };
  },
  watch: {
    showCartDialog() {
      this.showSlideOver = this.showCartDialog;
      this.showSlideOver
        ? this.$nuxt.$emit("hideChat")
        : this.$nuxt.$emit("showChat");
      window.dataLayer?.push({
        event: "screen_view",
        screen_name: "add_to_cart",
      });
    },
  },
  created() {
    this.$nuxt.$on("disableContinue", (status) => {
      this.disableTabChange = status;
    });
  },
  methods: {
    handleClickAndMove() {
      if (!this.disableTabChange) {
          this.submit();
      }
      else{
        this.$emit("scrollToError");
      }
    },
    closeSlideOver() {
      this.showSlideOver = false;
      this.$emit("closeSlideOver");
    },
    submit() {
      if (this.onSubmit) {
        this.onSubmit();
        return;
      }

      window.dataLayer?.push({
        event: "add_to_cart",
        authentication_status:
          this.$store.state.account.user.email !== undefined,
      });
      // TODO loading from session to vue-store logic be move to mixin
      const existingSessionCartItems = sessionStorage.cartItems
        ? JSON.parse(sessionStorage.cartItems)
        : null;
      if (existingSessionCartItems) {
        this.$store.dispatch(
          "lineItems/FILL_CART_ITEMS",
          existingSessionCartItems
        );
      }

      this.$store.dispatch("lineItems/ADD_CART_ITEM", {
        ...this.$store.state.cartItem,
      });
      sessionStorage.cartItems = JSON.stringify(
        this.$store.state.lineItems.cartItems
      );

      this.$nuxt.$emit("cartItemsUpdated");
      this.$store.dispatch("cartItem/CART_ITEM_FLUSH");

      this.showSlideOver = false;
      this.$emit("closeSlideOver");

      this.$router.push(`/${this.$i18n.locale}/cart`);
    },
  },
  beforeUnmount() {
    this.$nuxt.$off("disableContinue");
  },
  async fetch() {
    try {
      const page = await butter(this.$config).page.retrieve(
        "product_description",
        "product-description-page",
        {
          locale: this.$i18n.locale,
          timeout: 10000,
        }
      );
      this.pageData = page?.data.data.fields;
    } catch (error) {
      console.error(error);
    }
  },
};
